// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__36mvb","log":"ModalInventoryLogs_log__xup3i","date":"ModalInventoryLogs_date__1HmhN","userName":"ModalInventoryLogs_userName__2M920"};